import { useEffect, useState } from "react";
import Button from "../Components/button";
import { useGlobalContext } from "../Context/GlobalContext";
import { snakeToSentenceCase } from "../Utils/String";
import { cobber_memory } from "../data/cobber_memory";
import { binaryToCommand } from "../Utils/Commands";
import { hasCobberSettings } from "../Lib/Devices";

const TestMode = () => {
    const { usbManager } = useGlobalContext();
    const [view, setView] = useState('');
    const [deviceInfo, setDeviceInfo] = useState<any>({});
    const [memoryMap, setMemoryMap] = useState([]);
    const [firmwareMap, setFirmwareMap] = useState<any>(JSON.parse(localStorage.getItem('firmware') ?? '[]'))
    const [searchValue, setSearchValue] = useState('');
    const [readAddress, setReadAddress] = useState('0x');
    const [erasePage, setErasePage] = useState(0);
    const [readValue, setReadValue] = useState('');

    useEffect(() => {
        const init = async () => {
            handleConnect();
        }

        init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getView = () => {
        if(view === 'general') {
            return <div>
                {Object.keys(deviceInfo).map((key) => (
                    <div key={key} style={{margin: '15px 0', paddingBottom: '5px', fontSize: "24px", display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #6FFBB0'}}>
                        <span>{snakeToSentenceCase(key)}:</span> <span style={{ fontWeight: 'bold'}}>{deviceInfo[key]}</span>
                    </div>
                ))}
            </div>  
        } else if(view === 'memory') {
            return <div>
                <input 
                    type="text" 
                    name="search" 
                    placeholder="Search Memory" 
                    style={{width: '100%', padding: '10px', fontSize: '16px', marginBottom: '20px'}}
                    onChange={(e) => setSearchValue((e.target as HTMLInputElement).value)}
                    value={searchValue}
                />
                <div style={{
                    margin: '15px 0',
                    paddingBottom: '5px',
                    fontSize: "24px",
                    display: 'flex',
                    borderBottom: '1px solid #6FFBB0'
                }}>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Address</span>
                    <span style={{ fontWeight: 'bold', flex: 3 }}>Description</span>
                    <span style={{ fontWeight: 'bold', flex: 3 }}>Command</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Binary</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Int</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Hex</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Int (Scram)</span>
                </div>
                <div className="dataList" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    {memoryMap.map((address: any) => {
                        const command = binaryToCommand(address.value.toString(2).padStart(8, '0'));
                        const addressDetails = cobber_memory.find(
                            (item) => `0x${item.Address}` === address.address
                        );
                        if (searchValue && !address.address.toLowerCase().includes(searchValue.toLowerCase())) return null;

                        return (
                        <div
                            key={address.address}
                            style={{
                                margin: '15px 0',
                                paddingBottom: '5px',
                                fontSize: '24px',
                                display: 'flex',
                                borderBottom: '1px solid #6FFBB0'
                            }}
                        >
                            <span style={{ flex: 1 }}>{address.address}</span>
                            <div style={{ flex: 3 }}>
                                <div>{addressDetails?.Function ?? ''}</div>
                                <div style={{fontSize: '10px'}}>{addressDetails?.Notes ?? ''}</div>
                            </div>
                            <span style={{ flex: 3 }}>
                                {address.address.replace('0x', '').charAt(0) === '7' || parseInt(address.address, 16) > 0xF828 ? 
                                    (command?.command + (command?.command ? ', ' + JSON.stringify(command?.data) : '')) : ''}
                            </span>
                            <span style={{ flex: 1 }}>
                                {address.value.toString(2).padStart(8, '0')}
                            </span>
                            <span style={{ flex: 1 }}>{address.value}</span>
                            <span style={{ flex: 1 }}>{'0x' + address.value.toString(16).toUpperCase().padStart(2, '0')}</span>
                            <span style={{ flex: 1 }}>{address.value ^ 0x15}</span>
                        </div>
                        );
                    })}
                    </div>
                </div>
        } else if(view === "utils") {
            return <div>
                <div>
                     <div style={{
                        margin: '30px 0 15px 0',
                        paddingBottom: '5px',
                        fontSize: "24px",
                        display: 'flex',
                        borderBottom: '1px solid #6FFBB0',
                    }}>
                        Read Value
                    </div>
                    <div style={{display: 'flex', marginTop: '30px'}}>
                        <div style={{flex: 2}}>
                            <span style={{margin: '0 10px'}}>Address:</span>
                            <input 
                                type="text" 
                                placeholder="Write Address" 
                                value={readAddress} onChange={(e) => setReadAddress(setAsHex(e.target.value))} 
                                style={{width: '80%', padding: '10px', fontSize: '16px', marginBottom: '10px'}} 
                            />
                        </div>
                        <div style={{flex: 1}}>
                            <Button text={'Read'} onClick={readFromAddress}/>
                        </div>  
                        <div style={{padding: '10px 20px', fontSize: '20px'}}>Value: {readValue}</div> 
                    </div>    
                    <div style={{
                        margin: '30px 0 15px 0',
                        paddingBottom: '5px',
                        fontSize: "24px",
                        display: 'flex',
                        borderBottom: '1px solid #6FFBB0',
                    }}>
                        Erase Page
                    </div>
                    <div style={{display: 'flex', marginTop: '30px'}}>
                        <div style={{flex: 2}}>
                            <span style={{margin: '0 10px'}}>Page Number:</span>
                            <input 
                                type="number" 
                                placeholder="Write Address" 
                                value={erasePage} onChange={(e) => setErasePage(parseInt(e.target.value))} 
                                style={{width: '80%', padding: '10px', fontSize: '16px', marginBottom: '10px'}} 
                            />
                        </div>
                        <div style={{flex: 1}}>
                            <Button text={'Erase'} onClick={eraseWholePage}/>
                        </div>   
                    </div>               
                </div>
            </div>
        } else if(view === 'verify') {
            return <div>
                <div style={{ display: 'flex'}}>
                    <div style={{width: '300px', marginRight: '10px'}}><Button text="Update Firmware Cache" onClick={saveCache}/></div>
                    <div style={{width: '300px', marginRight: '10px'}}><Button text="Run Compare in Console" onClick={compareToCache}/></div>
                    <div style={{width: '300px'}}><Button text="Update Variable Address Cache" onClick={setVariableAddresses}/></div>
                </div>
                <input 
                    type="text" 
                    name="search" 
                    placeholder="Search Memory" 
                    style={{width: '100%', padding: '10px', fontSize: '16px', margin: '20px 0'}}
                    onChange={(e) => setSearchValue((e.target as HTMLInputElement).value)}
                    value={searchValue}
                />
                <div style={{
                    margin: '15px 0',
                    paddingBottom: '5px',
                    fontSize: "24px",
                    display: 'flex',
                    borderBottom: '1px solid #6FFBB0'
                }}>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Address</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Binary</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Int</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Hex</span>
                    <span style={{ fontWeight: 'bold', flex: 1 }}>Int (Scram)</span>
                </div>
                <div className="dataList" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {firmwareMap.map((address: any) => {
                        if (searchValue && !address.address.toLowerCase().includes(searchValue.toLowerCase())) return null;

                        return (
                        <div
                            key={address.address}
                            style={{
                                margin: '15px 0',
                                paddingBottom: '5px',
                                fontSize: '24px',
                                display: 'flex',
                                borderBottom: '1px solid #6FFBB0'
                            }}
                        >
                            <span style={{ flex: 1 }}>{address.address} ({Number(address.address)})</span>
                            <span style={{ flex: 1 }}>
                                {address.value.toString(2).padStart(8, '0')}
                            </span>
                            <span style={{ flex: 1 }}>{address.value}</span>
                            <span style={{ flex: 1 }}>{'0x' + address.value.toString(16).toUpperCase().padStart(4, '0')}</span>
                            <span style={{ flex: 1 }}>{address.value ^ 0x15}</span>
                        </div>
                        );
                    })}
                </div>
            </div>
        }
    }

    const setAsHex = (value: string) => {
        if(value.includes('0x')) return value;
        else if(value === '0') return value + 'x'
        else return '0x' + value;
    }

    const eraseWholePage = () => {
        if(!erasePage) {
            alert('Please enter a valid page number');
            return;
        } 

        usbManager.erasePage(erasePage)
        .then((response: any) => {
            console.log(response);
            if (!response.isSuccess) alert('Erase Failed');
        })
        .catch((error) => {
            console.error('Error erasing page: ' + erasePage, error);
        });
    }

    const readFromAddress = () => {
        if(!readAddress) {
            alert('Please enter a valid address');
            return;
        } 

        usbManager.readMemory(parseInt(readAddress, 16), parseInt(readAddress, 16))
        .then((response: any) => {
            if (!response.isSuccess) alert('Failed Reading');
            else setReadValue(response.dataList[0] ? response.dataList[0] : -1); 
        })
        .catch((error) => {
            console.error('Error erasing page: ' + erasePage, error);
        });
    }

    const saveCache = async () => {
        console.log('Saving');
        const data = hasCobberSettings(parseInt(deviceInfo.DEVICE_TYPE)) ? 
            await usbManager.usbDevice?.getDataRange(0x0000, 0x4000) : 
            await usbManager.usbDevice?.getDataRange(0x0000, 0x3FFF);
        localStorage.setItem('firmware', JSON.stringify(data));
        setFirmwareMap(data);
        console.log('Done');
    }

    const compareToCache = async() => {
        console.log('Comparing');
        const prev = JSON.parse(localStorage.getItem('firmware') ?? '');

        const live = hasCobberSettings(parseInt(deviceInfo.DEVICE_TYPE)) ? 
            await usbManager.usbDevice?.getDataRange(0x0000, 0x4000) : 
            await usbManager.usbDevice?.getDataRange(0x3FFF, 0x0000);
        const mismatch: any = [];
        live.forEach((address: any) => {
            if(
                address.value !== prev.find((p: any) => p.address === address.address).value 
                && !JSON.parse(localStorage.getItem('variable') ?? '[]').find((v: any) => v.address === address.address)
            ) {
                mismatch.push({address: address.address, prevVal: prev.find((p: any) => p.address === address.address).value, liveVal: address.value});
            }
        })
        console.log(mismatch);
    }

    const setVariableAddresses = async() => {
        console.log('Setting Addresses');
        const prev = JSON.parse(localStorage.getItem('firmware') ?? '');

        const live = hasCobberSettings(parseInt(deviceInfo.DEVICE_TYPE)) ? 
            await usbManager.usbDevice?.getDataRange(0x0200, 0x31ED) : 
            await usbManager.usbDevice?.getDataRange(0x3FFF, 0x0000);
        const mismatch: any = [];
        const cur = JSON.parse(localStorage.getItem('variable') ?? '[]');
        live.forEach((address: any) => {
            if(address.value !== prev.find((p: any) => p.address === address.address).value) {
                if(!cur.find((c: any) => c.address === address.address)) 
                    mismatch.push({address: address.address, prevVal: address.value, liveVal: prev.find((p: any) => p.address === address.address).value});
            }
        })
        console.log(mismatch.filter((m: any) => !cur.includes(m)).length + ' New')
        localStorage.setItem('variable', JSON.stringify([...cur, ...mismatch.filter((m: any) => !cur.includes(m))]));
    }

    const handleConnect = async () => {
        if(Object.keys(deviceInfo).length === 0) {
            let info;
            await usbManager.setSelected();
            if(usbManager.connectedDevices.length !== 1) {
                info = await usbManager.getDevices(true)
            } else {
                info = usbManager.usbDevice?.getDevDetails();
            }
        
            if (!info) return;

            delete info['isSuccess'];

            // convert UUID to 2 digit hex by adding a space between every 2 characters
            info.DEVICE_UUID = info.DEVICE_UUID.match(/.{1,2}/g)?.join(' ').toUpperCase();
            info.SERIAL_NUMBER = info.SERIAL_NUM.replace('[0x', '').replace(']', '').match(/.{1,2}/g)?.join(' ');

            // convert all numbers to hex
            for (let key in info) {
                if (typeof info[key] === 'number') {
                    info[key] = '0x' + info[key].toString(16).toUpperCase();
                }
            }

            setDeviceInfo(info);
        }
        setView('general');
    }

    const handleRead = async () => {
        setSearchValue('');
        const memory: any = hasCobberSettings(parseInt(deviceInfo.DEVICE_TYPE)) ? 
            await usbManager.usbDevice?.getDataRange(0x6E00, 0x73FF) : 
            await usbManager.usbDevice?.getDataRange(0xF800, 0xF8DE);

        console.log('Memory Read:', memory);
        setMemoryMap(memory);
        setView('memory');
    }

    return (
        <div className="dev-view">
            <div className="dev-wrapper">
                <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginBottom: '50px' }}>
                    <h1>Device Details</h1>
                    <div style={{width: '200px', marginLeft: '50px'}}>
                        <Button 
                            className={view === 'general' ? ' selected' : ''} 
                            text={Object.keys(deviceInfo).length ? 'Device Info' : 'Connect'} 
                            onClick={handleConnect}
                        />
                    </div>
                    {Object.keys(deviceInfo).length > 0 && 
                        <div style={{width: '200px', marginLeft: '50px'}}><Button text="Flash Memory" className={view === 'memory' ? ' selected' : ''}  onClick={handleRead}/></div>}
                    {Object.keys(deviceInfo).length > 0 && 
                        <div style={{width: '200px', marginLeft: '50px'}}><Button text="Firmware Memory" className={view === 'verify' ? ' selected' : ''}  onClick={() => {setSearchValue('');setView('verify')}}/></div>}
                    {Object.keys(deviceInfo).length > 0 && 
                        <div style={{width: '200px', marginLeft: '50px'}}><Button text="Tools" className={view === 'utils' ? ' selected' : ''}  onClick={() => setView('utils')}/></div>}
                </div>
                {getView()}
            </div>
        </div>
    );
}

export default TestMode;